module.exports = __webpack_public_path__ + "static/media/activity.90524dff.svg";